import { Booking, GetOptions } from "@/core";
import { repositoryHost } from "@/repositories";
import { serviceHost } from "@/services";
import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import { getNextPageParam } from "../utils/page-params";

const databaseService = serviceHost.getDatabaseService();
const bookingRepository = repositoryHost.getBookingRepository(databaseService);

export const useBookings = (options: GetOptions<Booking>) => {
  return useInfiniteQuery({
    queryKey: ["bookings", "get", JSON.stringify(options)],
    queryFn: ({ pageParam }) =>
      bookingRepository.getAll({
        ...options,
        pagination: {
          ...options.pagination,
          cursor: pageParam,
        },
      }),
    initialPageParam: "",
    getNextPageParam: getNextPageParam(options),
  });
};

export const useBookingsBySoId = (soId: string) => {
  return useQuery({
    queryKey: ["bookings", "by-so", soId],
    enabled: soId.length > 0,
    queryFn: async () =>
      bookingRepository.getAll({
        queryConstraints: [
          {
            field: "soId",
            operator: "==",
            value: soId,
          },
        ],
        orderBy: {
          field: "updatedAt",
          direction: "desc",
        },
        pagination: {
          limit: 100,
        },
      }),
  });
};
